/**
 * Analytics tracker for Store Picker module
 * Matches iOS StorePickerTracker.swift exactly
 */

import AnalyticsManager from '../AnalyticsManager'
import { ScreenName, ButtonName, ButtonLocation, ListName } from '../ScreenName'
import { AnalyticsParameters } from '../AnalyticsParameters'
import { AnalyticsEvent } from '../AnalyticsEvents'

/**
 * Protocol/interface for StorePickerTracker
 * Matches iOS StorePickerTrackerProtocol
 */
export interface StorePickerTrackerProtocol {
  trackOpenScreen(): void
  trackStoreSelected(storeId: number, storeName: string | null): void
  trackContinueButtonClicked(): void
  trackStoreSelectionCompleted(storeId: number, storeName: string | null, previousStoreId: number | null): void
  trackStoresLoadSuccess(storeCount: number): void
}

/**
 * Store picker tracker implementation
 */
class StorePickerTracker implements StorePickerTrackerProtocol {
  private analyticsManager: AnalyticsManager

  constructor(analyticsManager: AnalyticsManager = AnalyticsManager.shared) {
    this.analyticsManager = analyticsManager
  }

  trackOpenScreen(): void {
    this.analyticsManager.trackScreenView(ScreenName.STORE_PICKER)
  }

  trackStoreSelected(storeId: number, storeName: string | null): void {
    const parameters: Record<string, any> = {
      [AnalyticsParameters.storeId]: storeId,
    }
    if (storeName) {
      parameters[AnalyticsParameters.storeName] = storeName
    }
    this.analyticsManager.trackSelectItem(ListName.STORES, ScreenName.STORE_PICKER, parameters)
  }

  trackContinueButtonClicked(): void {
    this.analyticsManager.trackButtonClick(
      ButtonName.STORE_PICKER_CONTINUE,
      ButtonLocation.BOTTOM,
      ScreenName.STORE_PICKER
    )
  }

  trackStoreSelectionCompleted(
    storeId: number,
    storeName: string | null,
    previousStoreId: number | null
  ): void {
    const parameters: Record<string, any> = {
      [AnalyticsParameters.storeId]: storeId,
    }

    if (storeName) {
      parameters[AnalyticsParameters.storeName] = storeName
    }

    if (previousStoreId !== null && previousStoreId !== undefined) {
      parameters[AnalyticsParameters.previousStoreId] = previousStoreId
    }

    this.analyticsManager.trackEvent(AnalyticsEvent.STORE_SELECTED, ScreenName.STORE_PICKER, parameters)
  }

  trackStoresLoadSuccess(storeCount: number): void {
    this.analyticsManager.trackEvent(AnalyticsEvent.STORE_LIST_LOADED, ScreenName.STORE_PICKER)
  }
}

export default StorePickerTracker

